import ReactHtmlParser from 'react-html-parser';

const HtmlParser = ( html ) => {
  return ( 
    <div>
      {ReactHtmlParser(html)}
    </div>
  )
}

export default HtmlParser